import React, { useEffect, useMemo, useState } from 'react';
import { useUser } from 'structure/user/UserContext';
import { NETWORK_SWITCH_DISPLAY } from 'store/constants/chain';
import { selectChain } from 'store/features/chain/chainActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { chainSelector } from 'store/selectors/chain';
import Select from 'libui/Select';
import {
  SelectOptionProps,
  SelectOptionPropsList,
} from 'interfaces/vault.interface';
import { Icon } from '@iconify/react';
import {
  getNetworkFromChainId,
  enabledNetworks,
} from '@dapp/multi-lib/network';
import { NetworkChainIds, NetworkProps } from '@dapp/multi-lib/network';
import { useSwitchChain } from 'wagmi';
import { useIsSafeWalletContext } from 'utils/hooks/useIsSafeWallectContext';
import { Button } from '@dapp/multi-lib/sdaoui/Button';

const SwitchNetwork = ({
  networkDisplayType,
}: {
  networkDisplayType: string;
}) => {
  const { connector, chainId } = useUser();
  const { switchChain } = useSwitchChain();
  const dispatch = useAppDispatch();
  const selectedNetwork = useAppSelector(chainSelector);
  const { showCardanoStaking } = useAppSelector((state) => state.chain);
  const [currentNetwork, setCurrentNetwork] = useState<NetworkProps>();
  const [networkValue, setNetworkValue] = useState<SelectOptionPropsList>();
  const [networkList, setNetworkList] = useState<SelectOptionPropsList>();
  const isSafeWalletContext = useIsSafeWalletContext();
  const networks = useMemo(() => {
    if (isSafeWalletContext) {
      return enabledNetworks.filter(
        (network) => network.id === selectedNetwork
      );
    }

    return enabledNetworks;
  }, [isSafeWalletContext]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleNetworkChange = ({ id }: { id: any }) => {
    switchChain?.({ chainId: id });
    dispatch(
      selectChain({
        newChainId: id,
        connector,
        currentChainId: chainId,
      })
    );
  };

  useEffect(() => {
    setCurrentNetwork(getNetworkFromChainId(chainId ?? selectedNetwork));
  }, [chainId, selectedNetwork]);

  useEffect(() => {
    if (networkDisplayType === NETWORK_SWITCH_DISPLAY.DROPDOWN) {
      const networkArray: SelectOptionProps[] = [];

      networks.map((network) => {
        const currentItem: SelectOptionProps = {
          label: (
            <div className='flex'>
              <Icon icon={network.icon} width='16' height='16' />
              <div className='ml-5 text-sm text-white'>{network.name}</div>
            </div>
          ),
          id: network.id as NetworkChainIds,
          name: network.name,
        };

        if (network === currentNetwork) setNetworkValue([currentItem]);
        networkArray.push(currentItem);
      });

      setNetworkList(networkArray);
    }
  }, [networkDisplayType, currentNetwork, showCardanoStaking]);

  return (
    <>
      {networkDisplayType === NETWORK_SWITCH_DISPLAY.DROPDOWN ? (
        <Select
          backspaceRemoves={false}
          clearable={false}
          deleteRemoves={false}
          searchable={false}
          placeholder=''
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          value={networkValue as any}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={networkList as any}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(params: any) => {
            handleNetworkChange(params?.value[0]?.id);
          }}
        />
      ) : (
        <div className='flex flex-wrap gap-2'>
          {networks.map((network, index) => (
            <React.Fragment key={network.id}>
              <Button
                key={index}
                // variantStyle={currentNetwork === network ? 'primary' : 'accent'}
                size='small'
                style='neutral-dark'
                className={
                  currentNetwork === network
                    ? 'gap-1 border-borderDark-default font-bold'
                    : 'gap-1 font-bold'
                }
                onClick={() => handleNetworkChange(network)}
              >
                <Icon icon={network.icon} width='16' height='16' />
                {network.name}
              </Button>
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default React.memo(SwitchNetwork);
